/**
 * Google OAuth utilities for handling OAuth 2.0 authorization flow
 */

/**
 * Generate Google OAuth authorization URL with CSRF protection
 * @returns {string} Google OAuth authorization URL
 */
export const generateGoogleOAuthUrl = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = `${window.location.origin}/auth/callback/google`;
    const state = crypto.randomUUID();

    // Debug logging
    console.log('=== Google OAuth Debug ===');
    console.log('Client ID:', clientId);
    console.log('Redirect URI:', redirectUri);
    console.log('Window origin:', window.location.origin);
    console.log('State:', state);

    // Validation
    if (!clientId) {
        console.error('ERROR: REACT_APP_GOOGLE_CLIENT_ID is not set!');
        alert('Google OAuth is not configured. Missing REACT_APP_GOOGLE_CLIENT_ID.');
        throw new Error('Missing REACT_APP_GOOGLE_CLIENT_ID');
    }

    // Store state for CSRF validation (validated in GoogleCallback component)
    sessionStorage.setItem('oauth_state', state);

    const params = new URLSearchParams({
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: 'code',
        scope: 'openid email profile',
        state: state,
        access_type: 'offline',
        prompt: 'select_account' // Always show account picker
    });

    const oauthUrl = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
    console.log('Full OAuth URL:', oauthUrl);
    console.log('=========================');

    return oauthUrl;
};

/**
 * Initiate Google OAuth flow by redirecting to Google's authorization page
 */
export const initiateGoogleOAuth = () => {
    const url = generateGoogleOAuthUrl();
    window.location.href = url;
};
